import { useCallback, useState } from 'react';

import { Icon, Button } from '@febos-io/design';
import {
  ReactstrapInput as Input,
  ReactstrapInputGroup as InputGroup,
  ReactstrapInputGroupText as InputGroupText
} from '@febos-io/design';

import { useTranslation } from '../../../hooks';
import { filterTypes } from '../input';

export const InputFilterFind = ({ searchTitle, contentFilter, removeFilter, addFilter }) => {
  const [value, setValue] = useState('');
  const { t } = useTranslation();

  const handleQueryFilter = useCallback((e) => {
    if(e.key === "Enter") {
      const value = e.target.value;
      const filter = {
        id: contentFilter,
        type: filterTypes.CONTENT,
        isFixed: true,
        field: contentFilter,
        values: [value.trim()]
      };
      if (value) {
        addFilter(filter);
      } else {
        removeFilter(filter);
      }
    }
  },[addFilter, contentFilter, removeFilter]);

  const handleFind = () => {
    const filter = {
      id: contentFilter,
      type: filterTypes.CONTENT,
      isFixed: true,
      field: contentFilter,
      values: [value.trim()]
    };
    addFilter(filter);
  }

  return (
    <InputGroup className="input-group-merge ms-3">
      <InputGroupText>
        <Icon icon="pencil" fontSize="14px" />
      </InputGroupText>
      <Input
        id={contentFilter}
        placeholder={t(searchTitle)}
        onKeyDown={handleQueryFilter}
        value={value}
        onChange={e => setValue(e.target.value)}
      />
      <Button
        onClick={handleFind}
      >
        <Icon icon="search" fontSize="14px" />
      </Button>
    </InputGroup>
  )
}
